import React from 'react';

import { Icon, Pressable, Text } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';
export const SectionWrapper = Pressable.withConfig({
  marginTop: '$8',
  marginBottom: '$4',
});

export const SectionTitle = withTypography({
  variant: 'headerTwo',
  fontSize: 'xl',
});

const styles = StyleSheet.create({
  cardWrapper: {
    alignItems: 'center',
    backgroundColor: primitive.$mayoEggWhite,
    borderRadius: primitive.$borderRadius,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.$5,
    paddingVertical: spacing.$3_5,
    shadowOpacity: 0,
  },
  dateTimeWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'space-between',
    paddingHorizontal: spacing.$4,
  },
  timeWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

const createBox = (baseStyle: ViewStyle) => ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [baseStyle, style] });

export const CardWrapper = createBox(styles.cardWrapper);

export const CalendarIcon = Icon.withConfig({
  variant: 'calendar',
  size: 'md',
});

export const ArrowRightIcon = Icon.withConfig({
  variant: 'back',
  size: 'sm',
  style: {
    transform: [{ rotate: '180deg' }],
  },
});

export const DateTimeWrapper = createBox(styles.dateTimeWrapper);

export const DateWrapper = createBox({});

const TextLabel = Text.withConfig({
  variant: 'copyOne',
  fontSize: 'sm',
});

export const DayLabel = TextLabel.withConfig({
  fontWeight: 'bold',
  textTransform: 'capitalize',
});

export const DateLabel = TextLabel.withConfig({
  textTransform: 'capitalize',
});

export const TimeWrapper = createBox(styles.timeWrapper);

export const TimeLabel = TextLabel.withConfig({
  fontSize: 'md',
});
